import { render, staticRenderFns } from "./ModalListaRP.vue?vue&type=template&id=58fdf91c&scoped=true&"
import script from "./ModalListaRP.vue?vue&type=script&lang=js&"
export * from "./ModalListaRP.vue?vue&type=script&lang=js&"
import style0 from "./ModalListaRP.vue?vue&type=style&index=0&id=58fdf91c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdf91c",
  null
  
)

export default component.exports